/**
 * Returns the corresponding theme class based on the provided Sitecore template ID.
 *
 * Each page in Sitecore is associated with a template ID that identifies its type.
 * This utility maps those IDs to specific theme classes used for styling pages.
 *
 * @param templateId - The Sitecore template ID for the current page.
 * @returns A string representing the theme class to be applied (e.g., 'theme-lightblue', 'theme-blue').
 */
export function getPageThemeClass(templateId: string): string {
  // Map of known template IDs to their respective theme classes
  const themeMap: Record<string, string> = {
    '74D0E5B8-4EE3-43F0-9E9E-F9A755D6A420': 'blue', // Find care page
    '2B0DC9BB-9E4D-4B3F-AB08-5F14369A4CAF': 'lightblue', // Teaching sheet page
    'D2B65608-E58C-4E89-9A58-25FD1474C762': 'lightblue', // General page T2
    '6DE30456-2D7D-4D28-BF1B-2B2B8AA42E62': 'lightblue', // Provider Page
    '1FC43940-E22A-4F0A-8453-1DB23934AA03': 'blue', // Specialty Header
  };

  // Convert incoming templateId to uppercase for case-insensitive comparison
  // Return the matching theme class or fallback to 'theme-lightblue' if not found
  return themeMap[templateId.toUpperCase()] || 'lightblue';
}
